/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DropdownNoRepeater from 'DesignSystem/DropdownNoRepeater/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/OtherContactMethods/Content",
  from,
  onClick
  
}) {
let signupConfirmRequestContactMethodIdValueData = fromData.useDataValue({ viewPath,
context: 'signup_confirm_request',
path: 'contact_method_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<DropdownNoRepeater
  viewPath={`${viewPath}/DropdownNoRepeater`}
 from={from}
 data="signup_confirm_request.contact_method_id"
 selected={signupConfirmRequestContactMethodIdValueData}
 onClick={onClick}
 skipCallingOnClickWhenMoreThanOneItemAndNoneSelected={true}
 marginLeft={dtSpaceXs}
 width={200}
/>
{children}
</React.Fragment>)
}